/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type ClaimFeedback = {
    id: number;
    resolutionReason: string;
    resolutionStatus: ClaimFeedback.resolutionStatus;
    englishHeader: string;
    frenchHeader: string;
    englishMessage: string;
    frenchMessage: string;
    isActive: boolean;
};

export namespace ClaimFeedback {

    export enum resolutionStatus {
        CONFIRMED = 'CONFIRMED',
        PARTIALLY_CONFIRMED = 'PARTIALLY_CONFIRMED',
        DECLINED = 'DECLINED',
    }


}

